import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { _serverUrl2 } from "../../../config";
import { failed } from "../../../Utils/Alerts";
import { getCookie, setCookie } from "../../../Utils/Cookies";
import DataTableTool from "../../../Utils/DataTableTool";
import ProgressBar from "../../../Utils/ProgressBar";
import { loadingSc } from "../../Layout/AlertDiv";

export default function Statistics() {
  const baslangicTrh = 0;
  const bitisTrh = 0;

  const history = useHistory();

  const [ilceler, setIlceler] = useState([]);
  const [mahalleler, setMahalleler] = useState([]);

  const [selectedIlce, setSelectedIlce] = useState(getCookie("_i") == "" ? 0 : getCookie("_i"));
  const [mah, setMah] = useState(getCookie("_m") == "" ? 0 : getCookie("_m"));
  const [info, setInfo] = useState({
    numarataj_islem_durum: [],
    kontrol_durum: [],
    kontrol_durum_hsign: [],
    numarataj_7gunluk: [],
    toplam_numarataj_sayisi: "Yükleniyor..",
    direkduvar_islem_durum: [],
    direkduvar_7gunluk: [],
    numarataj_adres: [],
    direkduvar_adres: [],
    direk_tip: [
      { label: "DİREK", val: ".." },
      { label: "DUVAR", val: ".." },
    ],
    toplam_direkduvar_sayisi: "Yükleniyor..",
  });

  const getInfosFromNode = useCallback(async () => {
    loadingSc(true);
    let tempInfo = {
      numarataj_islem_durum: [],
      kontrol_durum: [],
      kontrol_durum_hsign: [],
      numarataj_7gunluk: [],
      numarataj_adres: [],
      direkduvar_adres: [],
      toplam_numarataj_sayisi: "Yükleniyor...",
      direkduvar_islem_durum: [],
      direkduvar_7gunluk: [],
      direk_tip: [
        { label: "DİREK", val: ".." },
        { label: "DUVAR", val: ".." },
      ],
      toplam_direkduvar_sayisi: "Yükleniyor..",
    };

    await axios
      .get(_serverUrl2 + "/main/ilce")

      .then((res) => {
        if (res.data.status) {
          setIlceler(res.data.rows);
        } else {
          failed("Veriler Getirilirken Hata Oluştu. " + res.data.error);
        }
      });

    await axios
      .post(_serverUrl2 + "/statics/hsignByType_Filter", { baslangic: baslangicTrh, bitis: bitisTrh, ilce: selectedIlce, mah: mah })
      .then((res) => {
        if (res.data.status) {
          tempInfo.numarataj_islem_durum = res.data.rows;
          let sayi = 0;
          res.data.rows.map((d) => {
            return (sayi = sayi + parseInt(d.val));
          });
          tempInfo.toplam_numarataj_sayisi = sayi;
        } else {
          failed("Veriler Getirilirken Hata Oluştu. " + res.data.error);
        }
      })
      .catch((err) => {
        failed("Veriler Getirilirken Hata Oluştu.. " + err);
      });

    await axios
      .post(_serverUrl2 + "/statics/signByType_Filter", { baslangic: baslangicTrh, bitis: bitisTrh, ilce: selectedIlce, mah: mah })
      .then((res) => {
        if (res.data.status) {
          tempInfo.direkduvar_islem_durum = res.data.rows;
          let sayi = 0;
          res.data.rows.map((d) => {
            return (sayi = sayi + parseInt(d.val));
          });
          tempInfo.toplam_direkduvar_sayisi = sayi;
        } else {
          failed("Veriler Getirilirken Hata Oluştu. " + res.data.error);
        }
      })
      .catch((err) => {
        failed("Veriler Getirilirken Hata Oluştu.. " + err);
      });

    await axios
      .post(_serverUrl2 + "/statics/kontrolDurumSign", { baslangic: baslangicTrh, bitis: bitisTrh, ilce: selectedIlce, mah: mah })
      .then((res) => {
        if (res.data.status) {
          tempInfo.kontrol_durum = res.data.rows;
        } else {
          failed("Veriler Getirilirken Hata Oluştu. " + res.data.error);
        }
      })
      .catch((err) => {
        failed("Veriler Getirilirken Hata Oluştu.. " + err);
      });

    await axios
      .post(_serverUrl2 + "/statics/kontrolDurumHsign", { baslangic: baslangicTrh, bitis: bitisTrh, ilce: selectedIlce, mah: mah })
      .then((res) => {
        if (res.data.status) {
          tempInfo.kontrol_durum_hsign = res.data.rows;
        } else {
          failed("Veriler Getirilirken Hata Oluştu. " + res.data.error);
        }
      })
      .catch((err) => {
        failed("Veriler Getirilirken Hata Oluştu.. " + err);
      });

    await axios
      .post(_serverUrl2 + "/statics/hsignByAdres_Filter", { baslangic: baslangicTrh, bitis: bitisTrh, ilce: selectedIlce, mah: mah })
      .then((res) => {
        if (res.data.status) {
          tempInfo.numarataj_adres = res.data.rows;
        } else {
          failed("Veriler Getirilirken Hata Oluştu. " + res.data.error);
        }
      })
      .catch((err) => {
        failed("Veriler Getirilirken Hata Oluştu.. " + err);
      });

    await axios
      .post(_serverUrl2 + "/statics/signByAdres_Filter", { baslangic: baslangicTrh, bitis: bitisTrh, ilce: selectedIlce, mah: mah })
      .then((res) => {
        if (res.data.status) {
          tempInfo.direkduvar_adres = res.data.rows;
        } else {
          failed("Veriler Getirilirken Hata Oluştu. " + res.data.error);
        }
      })
      .catch((err) => {
        failed("Veriler Getirilirken Hata Oluştu.. " + err);
      });

    await axios
      .post(_serverUrl2 + "/statics/signBySignType_Filter", { baslangic: baslangicTrh, bitis: bitisTrh, ilce: selectedIlce, mah: mah })
      .then((res) => {
        if (res.data.status) {
          tempInfo.direk_tip = res.data.rows;
        } else {
          failed("Veriler Getirilirken Hata Oluştu. " + res.data.error);
        }
      })
      .catch((err) => {
        failed("Veriler Getirilirken Hata Oluştu.. " + err);
      });
    await axios
      .get(_serverUrl2 + "/statics/hsignStatusByDate")
      .then((res) => {
        if (res.data.status) {
          tempInfo.numarataj_7gunluk = res.data.rows;
        } else {
          failed("Veriler Getirilirken Hata Oluştu. " + res.data.error);
        }
      })
      .catch((err) => {
        failed("Veriler Getirilirken Hata Oluştu. " + err);
      });

    await axios
      .get(_serverUrl2 + "/statics/signStatusByDate")
      .then((res) => {
        if (res.data.status) {
          tempInfo.direkduvar_7gunluk = res.data.rows;
        } else {
          failed("Veriler Getirilirken Hata Oluştu. " + res.data.error);
        }
      })
      .catch((err) => {
        failed("Veriler Getirilirken Hata Oluştu. " + err);
      });
    setInfo(tempInfo);
    loadingSc(false);
    // console.log("aaa", tempInfo)
  }, [mah, selectedIlce]);

  const onChangeIlce = async (e) => {
    setCookie("_i", e.target.value, 1);
    setSelectedIlce(e.target.value);
    if (e.target.value != 0) {
      await axios.get(_serverUrl2 + "/main/mah/" + e.target.value).then((res) => {
        setMahalleler(res.data.rows);
      });
    } else {
      setMahalleler([]);
      setMah(0);
      document.getElementById("mah").value = "0";
    }
  };
  const onChangeMahalle = async (e) => {
    setCookie("_m", e.target.value, 1);
    setMah(e.target.value);
  };

  const SayfaDurum = () => {
    if (document.getElementById("konu").value == "Personel Çalışmaları") {
      history.push("/dashboard/calisma");
    } else {
      history.push("/dashboard");
    }
  };

  useEffect(() => {
    getInfosFromNode();

    return () => {};
  }, [selectedIlce, mah, getInfosFromNode]);

  return (
    <div className="row" style={{ justifyContent: "center" }}>
      <div className="col-sm-5" style={{ flexDirection: "column", minWidth: "200px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox">
          <div className="header mb-0">İlçe/Mahalle</div>
          <div className="content d-flex d-inline">
            <select onChange={(e) => onChangeIlce(e)} className="form-control form-select" style={{ width: "50%" }}>
              <option value="0">Hepsi</option>
              {ilceler.map((d, i) => {
                return (
                  <option key={i} value={d.maks_kimlik_no}>
                    {d.ad}
                  </option>
                );
              })}
            </select>
            <select id="mah" onChange={(e) => onChangeMahalle(e)} className="form-control form-select" style={{ width: "50%" }}>
              <option value="0">Hepsi</option>
              {mahalleler.map((d, i) => {
                return (
                  <option key={i} value={d.mah_id}>
                    {d.mah_adi}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </div>

      <div className="col-sm-3" style={{ flexDirection: "column", minWidth: "200px", flexWrap: "wrap", display: "flex", flexGrow: 1 }}>
        <div className="textBox">
          <div className="header mb-0">Konu</div>
          <div className="content">
            <select className="form-control form-select" id="konu" onChange={() => SayfaDurum()}>
              <option>Numarataj ve Direk/Duvar</option>
              <option>Personel Çalışmaları</option>
            </select>
          </div>
        </div>
      </div>
      <div className="col-sm-12">&nbsp;</div>

      <div className="col-sm-12">
        <div className="textBox" style={{ width: "100%", padding: "0px" }}>
          <div className="header mb-0" style={{ padding: "0px" }}>
            Numarataj
          </div>
        </div>
      </div>

      <div className="col-sm-12" style={{ padding: "0px", flexDirection: "columnReverse", minWidth: "150px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%", padding: "0px" }}>
          <div className="header mb-0">Numarataj Genel Durum</div>
          <div className="content" style={{ padding: "0px", overflow: "hidden" }}>
            <div className="row" style={{ padding: "10px" }}>
              <div className="col-12">
                <ProgressBar
                  total={
                    info.numarataj_islem_durum.length == 0
                      ? []
                      : info.numarataj_islem_durum.map((d) => {
                          return d.val;
                        })
                  }
                  data={
                    info.numarataj_islem_durum.length == 0
                      ? []
                      : info.numarataj_islem_durum
                          .filter((d) => d.label != "YAPILMADI")
                          .map((d) => {
                            return d.val;
                          })
                  }
                  label="Toplam Numarataj Sayısı"
                  color="		#B2DFDB"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "200px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%", padding: "0px" }}>
          <div className="header mb-0">Numarataj İşlem Durumları</div>
          <div className="content" style={{ padding: "0px" }}>
            <DataTableTool
              routeObject={{
                title: "Numarataj İşlem Durumlarına Göre ",
                api: "/statics/hsignByType_Filter/table",
                filter: { baslangic: baslangicTrh, bitis: bitisTrh, ilce: selectedIlce, mah: mah },
                type: "numarataj", // 'calisma' , 'numarataj' , 'direkduvar'
              }}
              allData={info.numarataj_islem_durum}
              label={info.numarataj_islem_durum.map((d) => {
                return d.label;
              })}
              data={info.numarataj_islem_durum.map((d) => {
                return d.val;
              })}
            />
          </div>
        </div>
      </div>

      <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "200px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%" }}>
          <div className="header mb-0">{selectedIlce == 0 ? "İlçelere Göre Numarataj Sayıları" : "Mahallelere Göre Numarataj Sayıları"}</div>
          <div className="content">
            <DataTableTool
              single={false}
              routeObject={{
                title: "Numarataj İlçelere Göre ",
                api: "/statics/hsignByAdres_Filter/table",
                filter: { baslangic: baslangicTrh, bitis: bitisTrh, ilce: selectedIlce, mah: mah },
                type: "numarataj", // 'calisma' , 'numarataj' , 'direkduvar'
              }}
              showChart={false}
              allData={info.numarataj_adres}
              label={info.numarataj_adres.map((d) => {
                return d.label;
              })}
              data={info.numarataj_adres.map((d) => {
                return d.val;
              })}
            />
          </div>
        </div>
      </div>
      <div className="col-sm-3" style={{ flexDirection: "columnReverse", minWidth: "200px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%" }}>
          <div className="header mb-0">Numarataj Kontrol Durumları</div>
          <div className="content">
            <DataTableTool
              routeObject={{
                title: "Numarataj Kontrol Durumlarına Göre ",
                api: "/statics/kontrolDurumHsign/table",
                filter: { baslangic: baslangicTrh, bitis: bitisTrh, ilce: selectedIlce, mah: mah },
                type: "numarataj", // 'calisma' , 'numarataj' , 'direkduvar'
              }}
              allData={info.kontrol_durum_hsign}
              label={info.kontrol_durum_hsign.map((d) => {
                return d.label;
              })}
              data={info.kontrol_durum_hsign.map((d) => {
                return d.val;
              })}
            />
          </div>
        </div>
      </div>

      <div className="col-sm-12">
        <div className="textBox" style={{ width: "100%", padding: "0px" }}>
          <div className="header mb-0" style={{ padding: "0px" }}>
            Direk/Duvar
          </div>
        </div>
      </div>
      <div className="col-sm-12" style={{ padding: "0px", flexDirection: "columnReverse", minWidth: "150px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%", padding: "0px" }}>
          <div className="header mb-0">Direk/Duvar Genel Durum</div>
          <div className="content" style={{ padding: "10px", overflow: "hidden" }}>
            <ProgressBar
              total={
                info.direkduvar_islem_durum.length == 0
                  ? []
                  : info.direkduvar_islem_durum.map((d) => {
                      return d.val;
                    })
              }
              data={
                info.direkduvar_islem_durum.length == 0
                  ? []
                  : info.direkduvar_islem_durum
                      .filter((d) => d.label != "YAPILMADI")
                      .map((d) => {
                        return d.val;
                      })
              }
              label="Toplam Numarataj Sayısı"
              color="		#B2DFDB"
            />
          </div>
        </div>
      </div>

      <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "200px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%" }}>
          <div className="header mb-0">Direk/Duvar İşlem Durumları</div>
          <div className="content">
            <DataTableTool
              routeObject={{
                title: "Direk/Duvar İşlem Durumlarına Göre ",
                api: "/statics/signByType_Filter/table",
                filter: { baslangic: baslangicTrh, bitis: bitisTrh, ilce: selectedIlce, mah: mah },
                type: "direkduvar", // 'calisma' , 'numarataj' , 'direkduvar'
              }}
              allData={info.direkduvar_islem_durum}
              label={info.direkduvar_islem_durum.map((d) => {
                return d.label;
              })}
              data={info.direkduvar_islem_durum.map((d) => {
                return d.val;
              })}
            />
          </div>
        </div>
      </div>

      <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "200px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%" }}>
          <div className="header mb-0">{selectedIlce == 0 ? "İlçelere Göre Direk/Duvar Sayıları" : "Mahallelere Göre Direk/Duvar Sayıları"}</div>
          <div className="content">
            <DataTableTool
              single={false}
              routeObject={{
                title: "Direk/Duvar İlçelere Göre ",
                api: "/statics/signByAdres_Filter/table",
                filter: { baslangic: baslangicTrh, bitis: bitisTrh, ilce: selectedIlce, mah: mah },
                type: "direkduvar", // 'calisma' , 'numarataj' , 'direkduvar'
              }}
              showChart={false}
              allData={info.direkduvar_adres}
              label={info.direkduvar_adres.map((d) => {
                return d.label;
              })}
              data={info.direkduvar_adres.map((d) => {
                return d.val;
              })}
            />
          </div>
        </div>
      </div>

      <div className="col-sm-12" style={{ flexDirection: "columnReverse", minWidth: "200px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%" }}>
          <div className="header mb-0">Direk/Duvar Kontrol Durumları</div>
          <div className="content">
            <DataTableTool
              routeObject={{
                title: "Direk/Duvar Kontrol Durumlarına Göre ",
                api: "/statics/kontrolDurumSign/table",
                filter: { baslangic: baslangicTrh, bitis: bitisTrh, ilce: selectedIlce, mah: mah },
                type: "direkduvar", // 'calisma' , 'numarataj' , 'direkduvar'
              }}
              allData={info.kontrol_durum}
              label={info.kontrol_durum.map((d) => {
                return d.label;
              })}
              data={info.kontrol_durum.map((d) => {
                return d.val;
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
